import { isEmpty } from 'lodash'
import { largeSizes, legendDefault } from '.'
import { defaultExportMenu, getStackedSeries } from '../helpers'

export default ({ config, data, color, legendLabels, size = 'sm' }) => {
  const { labelColor } = color
  const { series, ...restConfig } = config
  const {
    title,
    xKey,
    scrollbar,
    labelsRotation = 0,
    disabledAnimations = false,
    exportingMenu,
    axisRanges
  } = restConfig

  const chartConfig = {
    data: data,
    autoDispose: true,
    type: 'XYChart',
    series: getStackedSeries({
      series,
      otherConfig: { legendLabels, color, disabledAnimations, ...restConfig }
    }),
    scrollbarX: {
      disabled: !scrollbar,
      parent: 'bottomAxesContainer'
    },
    cursor: {},
    xAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: xKey
        },
        rangeChangeDuration: 500,
        renderer: {
          labels: {
            rotation: labelsRotation || 0,
            fontSize: !largeSizes.includes(size) && 10,
            fill: labelColor
          },
          grid: {
            template: {
              strokeWidth: 0,
              fill: labelColor
            }
          },
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          minGridDistance: 60,
          cellStartLocation: 0.1,
          cellEndLocation: 0.9
        }
      }
    ],
    yAxes: [
      {
        title: {
          text: title || null,
          fill: labelColor,
          fontSize: !largeSizes.includes(size) && 12
        },
        axisRanges: !isEmpty(axisRanges) && [
          {
            value: axisRanges?.value,
            grid: {
              stroke: axisRanges?.color || labelColor,
              strokeWidth: 1,
              strokeOpacity: 1,
              strokeDasharray: axisRanges?.strokeDasharray || 0,
              above: true
            },
            label: {
              text: axisRanges?.text,
              inside: true,
              fill: axisRanges?.textColor || labelColor,
              verticalCenter: 'bottom',
              paddingBottom: 3
            }
          }
        ],
        id: 'CommonYAxis',
        type: 'ValueAxis',
        renderer: {
          line: {
            strokeOpacity: 0.3
          },
          labels: {
            fill: labelColor,
            fontSize: !largeSizes.includes(size) && 10
          }
        }
      },
      {
        type: 'ValueAxis',
        renderer: {
          opposite: true,
          line: {
            strokeOpacity: 0,
            fill: labelColor
          },
          labels: {
            fill: labelColor,
            fontSize: !largeSizes.includes(size) && 10
          }
        }
      }
    ],
    legend: legendDefault(labelColor)
  }
  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      chartConfig.exporting = defaultExportMenu
    } else {
      chartConfig.exporting = exportingMenu.config
    }
  }

  return chartConfig
}
